import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from "@angular/core";
import {
	MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
	MatLegacyDialogRef as MatDialogRef,
} from "@angular/material/legacy-dialog";
import { select, Store } from "@ngrx/store";
import { CoreState } from "@obg/ngx.core";
import { IconSelector } from "@obg/ngx.core.content";
import { ignoreEmpty } from "@obg/rxjs";
import { map, take } from "rxjs/operators";

import { LotbaSelfExclusionAlertContent } from "./lotba-self-exclusion-alert.model";

@Component({
	selector: "obg-lotba-self-exclusion-alert-container",
	templateUrl: "./lotba-self-exclusion-alert.container.html",
	styleUrls: ["./lotba-self-exclusion-alert.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class LotbaSelfExclusionAlertContainer {
	icon$ = this.store.pipe(
		select(this.iconSelector.get("alerticons")),
		ignoreEmpty(),
		take(1),
		map((items) => items.find((icon) => icon.key === "self-exclusion.regulator-logo"))
	);
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: LotbaSelfExclusionAlertContent | undefined,
		private store: Store<CoreState>,
		private iconSelector: IconSelector,
		private dialogRef: MatDialogRef<LotbaSelfExclusionAlertContainer>
	) {}

	closeDialog() {
		this.dialogRef.close();
	}
}
